import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { secondFinalEditorJobRetrieveRequest } from 'actions/jobs/employees';
import { isSecondFinalEditorJobDetailLoading } from 'selectors/loading';
import EmployeeJobDetailHOC from './EmployeeJobDetailHOC';
import JobDetail from './presenter';


const mapStateToProps = (state, props) => {
  const { id } = props.params;
  return {
    id,
    roleKey: 'secondFinalEditor',
    isLoading: isSecondFinalEditorJobDetailLoading(state, id),
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    retrieveRequest: secondFinalEditorJobRetrieveRequest,
  }, disptach)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeJobDetailHOC(JobDetail));